import i18n from "@src/common/lib/i18n";
import { Dic } from "$utils";

export const deviceOptions = function (deviceShow, areaShow) {
  return {
    add: "新增",
    edit: "修改",
    view: "详情",
    stripe: true,
    page: true,
    maxHeight: "500px",
    align: "center",
    header: false,
    selection: true,
    rowKey: "deviceId",
    reserveSelection: true, //分页缓存
    emptyText: i18n.t("cameraList.title.noData"),
    delBtn: false,
    editBtn: false,
    menu: false,
    column: [
      {
        label: "类型",
        prop: "type",
        align: "center",
        hide: true,
        overHidden: true,

        viewDisplay: false,
        formatter: (row, value) => {
          if (Number(row.type) === 2) {
            return "部件";
          } else if (Number(row.type) === 27) {
            return "消防主机";
          } else if (Number(row.type) === 28) {
            return "喷雾主机";
          } else if (Number(row.type) === 29) {
            return "放烟排烟主机";
          }
          // return Number(row.type) === 1 ? '主机' : '部件'
        },
        viewFormatter: (row, value) => {
          // return Number(row.type) === 1 ? '主机' : '部件'
          if (Number(row.type) === 2) {
            return "部件";
          } else if (Number(row.type) === 27) {
            return "消防主机";
          } else if (Number(row.type) === 28) {
            return "喷雾主机";
          } else if (Number(row.type) === 29) {
            return "放烟排烟主机";
          }
        }
      },
      {
        label: "设备类型",
        prop: "deviceMark",
        align: "center",
        overHidden: true,
        viewFormatter: (row, value) => {
          return Dic.findByValue("SENU087", Number(value));
        },
        formatter: (row, value) => {
          return value ? Dic.findByValue("SENU087", value) : "";
        }
      },
      {
        label: "主机编号",
        prop: "parentThirdDeviceId",
        overHidden: true
      },
      {
        label: "主机名称",
        prop: "parentDeviceName",
        overHidden: true,
        search: true
      },
      // {
      //   label: '主机说明',
      //   prop: 'parentThirdDeviceDesc',
      //   align: 'center',
      //   overHidden: true
      // },
      {
        label: "厂商",
        prop: "factoryName",
        hide: true,
        overHidden: true
      },
      {
        label: "消防型号",
        prop: "deviceVersion",
        overHidden: true,
        hide: true,
        viewDisplay: true,
        type: "select",
        dicData: Dic.find("SENU095"), //SENU095
        rules: [
          {
            required: true,
            message: "请选择消防型号",
            trigger: "blur"
          }
        ],
        viewFormatter: (row, value) => {
          return Dic.findByValue("SENU095", Number(value));
        },
        formatter: function (row, value) {
          return value ? Dic.findByValue("SENU095", value) : "";
        }
      },
      // {
      //   label: 'IP地址',
      //   prop: 'ip',
      //   overHidden: true
      // },
      // {
      //   label: '唯一标识号',
      //   prop: 'thirdDeviceId',
      //   align: 'center',
      //   overHidden: true
      // },
      // {
      //   label: '系统地址',
      //   prop: 'parentMac',
      //   overHidden: true,
      //   align: 'center'
      // },
      // {
      //   label: '类型标志',
      //   prop: 'typeMark',
      //   overHidden: true
      // },
      {
        label: "所在位置",
        prop: "buildingName",
        overHidden: true,
        // hide: deviceShow
        formatter: function (row, value) {
          return row.buildingName + "/" + row.floorName;
        }
      },
      {
        label: "状态",
        prop: "status",
        overHidden: true,
        addDisplay: true,
        viewDisplay: true,
        type: "select",
        dicData: [
          {
            label: "在线",
            value: "1"
          },
          {
            label: "离线",
            value: "0"
          }
        ],
        formatter: function (row, value) {
          console.log(row);
          return Number(value) === 1 ? "在线" : "离线";
        },
        viewFormatter: (row, value) => {
          return Number(value) === 1 ? "在线" : "离线";
        }
      }
      // {
      //   label: '回路',
      //   prop: 'loop',
      //   overHidden: true
      // },
    ]
  };
};
